module.exports = __webpack_public_path__ + "img/SES_40_01_013_257.333397c1.jpg";